import React from 'react';
import { Card, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
// TODO: according to designs it's supposed to handle RichText, which it doesn't now
const Banner = React.memo(({ message, submessage, testID }) => {
    return (React.createElement(Card, null,
        React.createElement(Stack, { flexDirection: "row" },
            React.createElement(VStack, null,
                React.createElement(IconValidationInvalid, { testID: `${testID}-banner-icon`, color: "$support.danger.surfaceOnColorAlt" })),
            React.createElement(VStack, { marginLeft: "$2", display: "flex", flex: 1 },
                React.createElement(Text, { type: "$bodyBase.default", textAlign: "left", nativeID: `${testID}-banner-message`, testID: `${testID}-banner-message` }, message),
                submessage && (React.createElement(Text, { type: "$bodyBase.strong", textAlign: "left", nativeID: `${testID}-banner-submessage`, testID: `${testID}-banner-submessage` }, submessage))))));
});
Banner.displayName = 'Banner';
export { Banner };
